/** Auto-generated from prod_blog - do not edit by hand */

export const blogPosts = [
  {
    id: 1,
    slug: "commercial-lease-dispute-attorney-atlanta-georgia",
    title: "Commercial Lease Dispute Attorneys in Atlanta, Georgia",
    date: "May 30, 2025",
    author: "Matthew Jones, Partner Jones & Booth Law",
    category: "Real Estate Law",
    excerpt: "Skilled commercial real estate litigation for landlords and tenants across Atlanta and Georgia.",
    content: `Commercial lease disputes can be costly and disruptive for businesses and property owners alike. Jones Booth Law provides skilled commercial real estate litigation representation across Atlanta and throughout Georgia.

## Common Commercial Lease Disputes in Georgia

- Non-payment of rent or operating expenses
- Alleged lease breaches by landlord or tenant
- Disputes over CAM (common area maintenance) charges
- Co-tenancy clause violations affecting retail tenants
- Lease termination, holdover, and eviction disputes
- Relocation and exclusivity clause enforcement
- Lease renewal option disagreements
- Disputes over permitted use, assignment, or sublease rights

## Georgia Commercial Lease Law

Unlike residential leases, commercial leases in Georgia are **largely governed by the terms negotiated between the parties**. Georgia courts generally enforce commercial lease provisions as written under the freedom-of-contract principle. That means the language in your lease — not a broad tenant-protection statute — usually controls the outcome.

Our attorneys are experienced in lease interpretation, default notices, and the strategic choice between negotiation, mediation, and Superior Court litigation.

## When to Act

Deadlines in commercial leases for notice, cure periods, and renewal options are often strict. Missing a notice window can waive rights you didn't know you had. Get advice before you withhold rent, change locks, or sign a settlement letter.

## Representation for Landlords and Tenants

Jones Booth Law represents both commercial landlords and business tenants in lease disputes throughout the Atlanta metro area. We work toward efficient resolution — but we are prepared to litigate in Georgia Superior Court when the other side won't negotiate in good faith.`,
    tags: ["commercial lease","real estate","Atlanta","litigation"]
  },
  {
    id: 2,
    slug: "partition-action-attorney-atlanta-georgia",
    title: "Partition Action Attorneys in Atlanta, Georgia",
    date: "May 30, 2025",
    author: "Matthew Jones, Partner Jones & Booth Law",
    category: "Real Estate Law",
    excerpt: "When co-owners of real property cannot agree, a partition action may be the solution.",
    content: `When co-owners of real property cannot agree on what to do with shared property, a partition action may be the solution. Jones Booth Law represents co-owners, heirs, and investors throughout Atlanta and Georgia.

## What Is a Partition Action?

A court proceeding that allows a co-owner to compel a **division or sale** of property when owners can't agree. Under O.C.G.A. § 44-6-140 et seq., Georgia courts can order:

- **Partition in kind** — physically dividing the land when feasible (more common with large rural parcels)
- **Partition by sale** — selling the property and distributing proceeds according to ownership shares

Most residential and commercial co-ownership disputes result in a court-ordered sale rather than a physical split.

## When Is a Partition Action Necessary?

- Heirs inherit property together and disagree on keeping or selling
- Business partners or investors dissolve a joint venture
- Unmarried couples who purchased together separate
- One co-owner wants to sell and the other refuses
- Multiple family members inherit with no clear succession plan

## Can One Owner Block a Sale?

Not forever. If co-owners can't reach agreement, any owner with an undivided interest can petition the court. The court can order a sale even over one owner's objection, subject to proper procedure and notice.

## The Partition Process in Georgia

Cases are filed in **Superior Court**. The court may appoint partitioners to evaluate the property, determine whether division in kind is practical, and oversee a public sale if necessary. Proceeds are distributed after costs according to each owner's share.

**Get advice before you stop contributing to expenses, move out, or deed your interest informally.** Partition cases go smoother with clean title records and documented ownership from the start.

Jones & Booth Law guides co-owners through partition actions across the Atlanta metro area and statewide.`,
    tags: ["partition action","real estate","co-ownership","Atlanta"]
  },
  {
    id: 3,
    slug: "quiet-title-action-attorney-atlanta-georgia",
    title: "Quiet Title Action Attorneys in Atlanta, Georgia",
    date: "May 30, 2025",
    author: "Matthew Jones, Partner Jones & Booth Law",
    category: "Real Estate Law",
    excerpt: "Resolve clouds on your property title so you can sell, refinance, or fully enjoy your real estate investment.",
    content: `A cloud on your property title can prevent you from selling, refinancing, or fully enjoying your real estate investment. Jones Booth Law represents property owners throughout Georgia in quiet title actions.

## What Is a Quiet Title Action?

A civil lawsuit filed in **Georgia Superior Court** to resolve competing claims or defects on a property's title. Under O.C.G.A. § 23-3-60 et seq., the court can adjudicate the rights of all parties and issue a judgment that conclusively establishes legal ownership — clearing the way for a clean sale or refinance.

## Common Reasons to File

- Adverse possession claims
- Gaps or errors in the chain of title
- Boundary line disputes between neighbors
- Improperly released mortgages, liens, or judgments
- Heir property with multiple undocumented owners
- Title defects following tax or foreclosure sales

## The Quiet Title Process

Cases typically involve a title search, identifying all parties with a potential interest, filing a petition in Superior Court, serving interested parties, and publishing notice to unknown claimants. A hearing before a Special Master may follow, with the court adopting a final report. **Most cases take 3–6 months**, though contested matters can run longer.

## Why Timing Matters

Buyers, lenders, and title insurers won't close on property with unresolved title issues. The longer a cloud sits, the more expensive and complicated resolution becomes. Address title problems before you list or apply for financing.

Jones & Booth Law handles quiet title actions across Georgia — from straightforward lien releases to complex heir property disputes.`,
    tags: ["quiet title","real estate","property law","Atlanta"]
  },
  {
    id: 4,
    slug: "residential-lease-dispute-attorney-atlanta-georgia",
    title: "Residential Lease Dispute Attorneys in Atlanta, Georgia",
    date: "May 30, 2025",
    author: "Matthew Jones, Partner Jones & Booth Law",
    category: "Real Estate Law",
    excerpt: "Straightforward, results-focused representation for tenants and landlords in residential lease disputes across Atlanta and North Georgia.",
    content: `Residential lease disputes can upend the lives of both tenants and landlords. Jones Booth Law provides straightforward, results-focused legal representation for clients throughout Atlanta and North Georgia.

## Types of Residential Lease Disputes We Handle

- Wrongful withholding of security deposits (O.C.G.A. § 44-7-30 et seq.)
- Landlord failure to maintain habitable conditions
- Unauthorized lease terminations or self-help evictions
- Retaliatory actions after tenants assert their rights
- Breach of lease terms by tenant or landlord
- Noise, nuisance, and neighbor-related complaints
- Disputes over lease renewal and move-out conditions
- Property damage claims and deduction disputes

## Georgia's Residential Landlord-Tenant Act

O.C.G.A. § 44-7-1 through § 44-7-81 governs security deposit handling, landlord duties to maintain habitable premises, required notice periods, and tenant remedies. Residential tenants have **more statutory protection** than commercial tenants — but you still need to follow notice and documentation requirements to preserve your claims.

## Security Deposit Disputes

Georgia law requires landlords to return security deposits within **one month** of the lease ending, with an **itemized written statement** of any deductions. Failure to comply can expose landlords to liability for the deposit amount plus attorney's fees in appropriate cases.

Tenants should photograph the unit at move-in and move-out. Landlords should document condition and send itemized statements on time. Both sides benefit from getting the process right the first time.

## We Represent Tenants and Landlords

Whether you're fighting an unfair deduction or enforcing lease terms against a non-compliant tenant, early legal advice prevents small disputes from becoming expensive litigation.`,
    tags: ["residential lease","landlord tenant","real estate","Atlanta"]
  },
  {
    id: 5,
    slug: "what-to-do-after-a-car-accident",
    title: "What to Do After a Car Accident: A Step-by-Step Guide",
    date: "February 23, 2025",
    author: "Matthew Jones, Partner Jones & Booth Law",
    category: "Personal Injury",
    excerpt: "What you do in the first minutes, hours, and days after a crash can directly impact your health, finances, and legal rights.",
    content: `Car accidents are overwhelming. What you do in the first minutes, hours, and days after a crash can directly impact your health, finances, and legal rights. Georgia gives injured drivers **two years** from the accident date to file most personal injury lawsuits — but evidence disappears fast, so acting early matters.

## 1. Prioritize Safety First

- Check yourself and passengers for injuries
- Call 911 if anyone is hurt
- Move vehicles out of traffic if safe
- Turn on hazard lights
- Seek medical advice even for minor-seeming injuries

## 2. Call the Police and Get a Report

A police report creates an official record insurers and courts rely on. Provide accurate facts, avoid speculating about fault, and request the report number before leaving. You can usually obtain a copy from the responding agency within a few days.

## 3. Gather Evidence at the Scene

- Photos of vehicle damage, license plates, road conditions, traffic signs, and visible injuries
- Names and contact info for all drivers and witnesses
- Insurance information and driver's license numbers
- Note the time, location, weather, and traffic conditions while memory is fresh

## 4. Seek Medical Attention Immediately

Some injuries — whiplash, concussions, internal bleeding — may not show symptoms for hours or days. Prompt care protects your health and creates documentation linking your injuries to the accident. Follow through on every referral and keep all bills and records.

## 5. Speak With a Personal Injury Attorney

An attorney can help you understand your claim, case value, how to deal with insurance adjusters, and applicable deadlines. Most firms, including Jones & Booth Law, offer free consultations for injury cases.

## 6. Notify Your Insurance Company

Most policies require prompt reporting — often within days. Provide basic facts only. Consider legal advice before giving a recorded statement or discussing fault in detail.

## 7. Be Careful What You Say (and Post)

Avoid discussing the accident on social media, apologizing at the scene, or speaking with the other driver's insurer without counsel. Anything you say can be used to minimize your claim.

## Common Mistakes to Avoid

- Delaying medical care
- Failing to document the scene
- Admitting fault at the scene
- Accepting the first settlement offer before knowing your full injuries
- Missing the statute of limitations

For a deeper look at fault and compensation in Georgia, see our guide on [car accident damages and comparative fault](/blog/georgia-car-accident-damages-and-comparative-fault).`,
    tags: ["car accident","personal injury","insurance","legal rights"]
  },
  {
    id: 6,
    slug: "how-to-choose-the-best-personal-injury-lawyer",
    title: "How to Choose the Best Personal Injury Lawyer for Your Case",
    date: "February 15, 2025",
    author: "Matthew Jones, Partner Jones & Booth Law",
    category: "Personal Injury",
    excerpt: "Practical steps for researching attorneys, interviewing candidates, and finding the right fit for your injury claim.",
    content: `Choosing the wrong attorney can cost you time, money, and peace of mind. Here's a practical framework for finding the right personal injury lawyer in Georgia.

## 1. Don't Just Pick the First One Online

Pre-paid advertisements and billboard counts are not indicators of quality. A firm's marketing budget tells you nothing about how they handle cases like yours.

## 2. Do Your Research

- Search the attorney's name on Google and the **State Bar of Georgia** website
- Check Martindale-Hubbell, Super Lawyers, and Avvo — but know some ratings are pay-to-play
- Read attorney bios for **trial experience**, not just settlements
- Look for reviews that mention communication and case outcomes, not just star counts

## 3. Interview the Attorney

Schedule a consultation before signing anything. Ask:

- Who will actually handle my case day to day?
- Have you taken cases like mine to trial?
- What is your fee structure — contingency or hourly?
- What is a realistic timeline for my type of claim?

**Red flags:** slow callbacks, vague fee answers, pressure to sign on the spot, or inability to explain your options clearly.

## 4. Communication and Availability

Your attorney should return calls within a reasonable time, show up prepared, and explain strategy in plain English — not jargon designed to impress you.

## 5. Ask About Litigation

Make sure the attorney can manage your case from pre-litigation through filing a lawsuit if necessary. Some firms settle everything because they rarely go to court. You don't want to accept less because your lawyer won't fight.

## Good Fit

Do you feel at ease? Can you ask hard questions and get straight answers? Trust matters. If something feels off in the consultation, keep looking.

Jones & Booth Law offers free consultations for personal injury cases across Georgia.`,
    tags: ["personal injury","attorney selection","legal advice"]
  },
  {
    id: 7,
    slug: "georgia-car-accident-damages-and-comparative-fault",
    title: "Georgia Car Accident Damages and Comparative Fault Explained",
    date: "January 10, 2025",
    author: "Matthew Jones, Partner Jones & Booth Law",
    category: "Personal Injury",
    excerpt: "How Georgia's modified comparative negligence rule affects your claim, and what damages you may recover after a crash.",
    content: `If you were injured in a car accident in Georgia, you may be entitled to compensation for medical bills, lost wages, pain and suffering, and long-term impairment. At Jones & Booth, we have represented hundreds of injured drivers and passengers across Georgia harmed by negligent motorists.

## Georgia's Comparative Fault Rule

Georgia follows **modified comparative negligence** under O.C.G.A. § 51-12-33. You can recover damages as long as you are **less than 50% at fault** for the crash. If you are 50% or more at fault, you recover nothing.

Your award is reduced by your percentage of fault. If total damages are \$100,000 and you are found 20% at fault, you recover \$80,000.

Insurance adjusters often assign fault aggressively. Documenting the scene, witness statements, and medical records early helps protect your claim.

## Common Causes of Car Accidents in Georgia

- Distracted driving
- Speeding and aggressive driving
- Failure to yield
- Running red lights or stop signs
- DUI and impaired driving
- Rear-end collisions
- Intersection and lane-change crashes

## What Damages Can You Recover?

In Georgia car accident cases, recoverable damages may include:

- **Medical expenses** — emergency care, surgery, rehab, and future treatment
- **Lost income** — wages missed and reduced earning capacity
- **Pain and suffering** — physical pain and emotional distress
- **Permanent disability** — lasting impairment from your injuries
- **Property damage** — vehicle repair or replacement

The value of a claim depends on injury severity, insurance coverage, liability clarity, and long-term impact — not a generic formula.

## Statute of Limitations

Georgia generally gives you **two years** from the date of the accident to file a personal injury lawsuit. Missing that deadline can bar your claim entirely. If you were injured in a car accident anywhere in Georgia, contact Jones & Booth Law for a free consultation.`,
    tags: ["car accident","comparative negligence","damages","personal injury","Georgia law"]
  }
];

export const getBlogPostById = (id) => {
  return blogPosts.find((post) => post.id === parseInt(id, 10));
};

export const getBlogPostBySlug = (slug) => {
  return blogPosts.find((post) => post.slug === slug);
};

export const getRelatedPosts = (currentPostSlug, limit = 2) => {
  const current = getBlogPostBySlug(currentPostSlug);
  if (!current) {
    return blogPosts.filter((post) => post.slug !== currentPostSlug).slice(0, limit);
  }

  const sameCategory = blogPosts.filter(
    (post) => post.slug !== currentPostSlug && post.category === current.category
  );
  const pool = sameCategory.length >= limit
    ? sameCategory
    : blogPosts.filter((post) => post.slug !== currentPostSlug);

  return pool.slice(0, limit);
};
